import {EtsyListing, EtsyListingStateEnum} from '@coolcolduk/etsy';
import {useGetAllListingsByShop} from './useGetAllListingsByShop';

export const useGetAllTemplateListings = (shopRecordId?: string): EtsyListing[] => {
  const data = useGetAllListingsByShop(shopRecordId, EtsyListingStateEnum.DRAFT, true);

  return Object.values(data).filter((l) => l.title.startsWith('template'));
};
